<template>

    <div class="">

        <app-head :title="page.meta_title || page.title">
            <meta name="description" :content="page.meta_description" v-if="page.meta_description">
        </app-head>

        <div v-html="page.content">
        </div>

    </div>

</template>

<script>

    export default {
        props: [
            'page',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>